import './index.scss';

export type StatusBadgeVariant =
  | 'accent'
  | 'active'
  | 'success'
  | 'pending'
  | 'passive'
  | 'suspended'
  | 'completed'
  | 'in-progress'
  | 'assigned'
  | 'brand'
  | 'rejected'
  | 'waiting'
  | 'user-response'
  | 'default'
  /** Alias of `default`, kept for existing call sites. */
  | 'neutral';

interface StatusBadgeProps {
  label: string;
  status: StatusBadgeVariant;
  appearance?: 'badge' | 'indicator';
  /** Leading status dot, for connection states. */
  dot?: boolean;
}

export const StatusBadge = ({
  label,
  status,
  appearance = 'badge',
  dot = false,
}: StatusBadgeProps) => {
  return (
    <span
      className={`c-status-badge c-status-badge--${status}${appearance === 'indicator' ? ' c-status-badge--indicator' : ''}`}
    >
      {dot || appearance === 'indicator' ? (
        <span className="c-status-badge__dot" aria-hidden="true" />
      ) : null}
      {label}
    </span>
  );
};
